import React from 'react';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';

import AdminUserModal from '../AdminUserModal';
import Link from '../../Link';
import Loader from '../../../components/Common/Loader';
import CustomPagination from '../../CustomPagination/CustomPagination';

import messages from '../../../locale/messages';
import { openAdminUserModal } from '../../../actions/siteadmin/modalActions';
import { deleteAdminUser } from '../../../actions/siteadmin/AdminUser/manageAdminUser';
import getCurrentPage from '../../../helpers/getCurrentPage';
import { censorEmail, decode } from '../../../helpers/queryEncryption';
import { demoRestrictionEncode } from '../../../actions/demoRestriction';

import { CommonAdminEditIcon, CommonAdminTrashIcon } from '../../Common/Assets/SVGIcon/CommonSvgIcon';

import bt from '../../../components/commonStyle.css';
import s from './AdminUserManagement.css';

class AdminUserManagement extends React.Component {
  static defaultProps = {
    data: [],
    roles: []
  };

  constructor(props) {
    super(props)
    this.state = {
      currentPage: 1,
      isRestrict: false,
    }
  }

  async componentDidMount() {
    const { demoRestrictionEncode } = this.props;
    const isRestrict = await demoRestrictionEncode({});
    this.setState({ isRestrict });
  }

  paginationData = (currentPage) => {
    const { refetch } = this.props;
    let variables = { currentPage };
    this.setState({ currentPage });
    refetch(variables);
  }

  handleDelete = async (id, currentPage) => {
    const { deleteAdminUser, refetch, data } = this.props;
    currentPage = await getCurrentPage({ results: data?.results, page: currentPage });
    let variables = { currentPage };
    const response = await deleteAdminUser(id, currentPage)
    if (response?.status == 200) {
      this.setState({ currentPage });
      refetch(variables);
    }
  }

  render() {
    const { data, openAdminUserModal, deleteAdminUser, roles, loading } = this.props;
    const { formatMessage } = this.props.intl;
    const { currentPage, isRestrict } = this.state;
    return (
      <div >
        <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.manageAdminUsers)}</h1>
        <AdminUserModal roles={roles} paginationData={this.paginationData} currentPage={currentPage} />
        <div className={s.exportDisplay}>
          <div />
          <div className={cx(s.exportTextSection)}>
            <Button
              className={cx(bt.btnPrimary)}
              onClick={() => openAdminUserModal('add')}>
              <FormattedMessage {...messages.addNewLabel} />
            </Button>
          </div>
        </div>
        {
          loading && <div>
            <Loader type="circle" />
          </div>
        }
        {!loading && <div className='tableOuterContainer'>
          <Table className="tableContainer">
            <thead>
              <tr>
                <th scope="col"><FormattedMessage {...messages.id} /></th>
                <th scope="col"><FormattedMessage {...messages.emailText} /></th>
                <th scope="col"><FormattedMessage {...messages.adminRole} /></th>
                <th scope="col"><FormattedMessage {...messages.edit} /></th>
                <th scope="col"><FormattedMessage {...messages.deleteAction} /></th>
              </tr>
            </thead>
            <tbody>
              {
                data?.results && data?.results?.length > 0 && data?.results?.map((value, key) => {
                  return (
                    <tr key={key}>
                      <td data-label={formatMessage(messages.id)}>{key + 1} </td>
                      <td data-label={formatMessage(messages.emailText)}>{isRestrict ? censorEmail(decode(value.email)) : decode(value.email)}</td>
                      <td data-label={formatMessage(messages.adminRole)}>{value.adminRole && value.adminRole.name}</td>
                      <td data-label={formatMessage(messages.editAction)}>
                        <div>
                          <Link noLink onClick={() => openAdminUserModal('edit', value, isRestrict)} className={s.noLink}>
                            <CommonAdminEditIcon className={cx(s.editIcon, 'editIconRTL')} />
                            <span className={s.vtrMiddle}>
                              <FormattedMessage {...messages.editAction} />
                            </span>
                          </Link>
                        </div>
                      </td>
                      <td data-label={formatMessage(messages.deleteAction)}>
                        <div>
                          <Link noLink onClick={() => this.handleDelete(value.id, currentPage)} className={s.iconBtn}>
                            <CommonAdminTrashIcon className={cx(s.editIcon, 'editIconRTL')} />
                            <span className={s.vtrMiddle}>
                              <FormattedMessage {...messages.deleteAction} />
                            </span>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  )
                })
              }
              {
                data?.results && data?.results?.length === 0 && <tr>
                  <td colspan="5" className={'tableNoRecordCel'}><FormattedMessage {...messages.noResult} /></td>
                </tr>
              }
            </tbody>
          </Table>
        </div>}
        {
          data?.results?.length > 0 &&
          <div className={cx(bt.space5, bt.spaceTop5)}>
            <CustomPagination
              total={data?.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.users)}
            />
          </div>
        }
      </div>
    );
  }
}

const mapState = (state) => ({});

const mapDispatch = {
  openAdminUserModal,
  deleteAdminUser,
  demoRestrictionEncode
};

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(AdminUserManagement)));